// extracted by mini-css-extract-plugin
module.exports = {"left":"doctorLogin_left__33Jso","left_tag":"doctorLogin_left_tag__1kN3M","left_desc":"doctorLogin_left_desc__3697E","batch":"doctorLogin_batch__1jDB7"};